import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BeginYourExperience() {
  return <section data-section-id="226206" id="կապ-մեզ-հետ" className="bg-background text-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24 sm:py-32 lg:py-40 light">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/orbital_cosmos_watermark.png)] bg-center bg-no-repeat opacity-[0.15] mix-blend-screen" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 text-center">
        <div className="mx-auto max-w-3xl !w-[900px]">
          <h2 className="font-default text-5xl font-bold tracking-tighter text-foreground uppercase !w-[850px] sm:text-6xl lg:text-7xl">Դարձե՛ք ուղեծրային հեղափոխության մասնակիցը</h2>
          
          <p className="mt-6 font-default text-lg tracking-widest text-muted-foreground sm:text-xl uppercase">Արբանյակային&nbsp; տվյալների վերլուծություն և քարտեզագրական լուծումներ</p>

          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <Button variant="ghost" size="lg" className="w-full text-base tracking-widest sm:w-auto font-default border-primary/20 hover:bg-primary/10" asChild>
              <Link to="/ServicesPage">ՄԵՐ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԸ</Link>
            </Button>
            
            <Button variant="default" size="lg" className="w-full text-base tracking-widest sm:w-auto font-default bg-primary text-primary-foreground hover:opacity-90 shadow-lg shadow-primary/20" asChild>
              <Link to="/#contactrequest">ԿԱՊ ՄԵԶ ՀԵՏ</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}